import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, API } from "@/lib/api";
import * as Icons from "lucide-react";

export default function ExportPage() {
  const { sid } = useParams();
  const [safety, setSafety] = useState(null);
  useEffect(() => { api.get("/safety").then((r) => setSafety(r.data)); }, []);

  return (
    <div className="p-8 max-w-4xl" data-testid="export-page">
      <h1 className="font-display text-3xl text-stone-900">Export &amp; Safety</h1>

      <div className="bg-white border border-stone-200 rounded-xl p-5 mt-6">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-stone-700 mb-3">Archival exports (this snapshot)</h2>
        <div className="flex gap-3 flex-wrap">
          <a href={`${API}/snapshots/${sid}/export.json`} data-testid="export-json"
            className="inline-flex items-center gap-2 border border-stone-300 px-4 py-2 rounded-lg text-sm hover:bg-stone-100">
            <Icons.FileJson className="w-4 h-4" /> Complete JSON
          </a>
          <a href={`${API}/snapshots/${sid}/export.xlsx`} data-testid="export-xlsx"
            className="inline-flex items-center gap-2 border border-stone-300 px-4 py-2 rounded-lg text-sm hover:bg-stone-100">
            <Icons.Sheet className="w-4 h-4" /> Human-readable XLSX
          </a>
        </div>
        <p className="text-xs text-stone-400 mt-3">Exports are scoped to this snapshot and contain no credentials, no session material, and strip incidental customer fields.</p>
      </div>

      <div className="bg-[#1a1a17] text-stone-300 rounded-xl p-5 mt-6" data-testid="safety-panel">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-amber-200 mb-3 flex items-center gap-2">
          <Icons.ShieldCheck className="w-4 h-4" /> Read-only safety manifest
        </h2>
        {!safety ? (
          <p className="text-stone-500 text-sm">Loading…</p>
        ) : (
          <div className="space-y-4 text-sm">
            <div><div className="text-stone-500 text-xs uppercase">Method policy</div><div className="text-emerald-300">{safety.method_policy}</div></div>
            <div><div className="text-stone-500 text-xs uppercase">Locked hosts</div><div className="mono">{safety.hosts.join(", ")}</div></div>
            <div><div className="text-stone-500 text-xs uppercase">Customer endpoints</div><div className="text-rose-300">{safety.customer_endpoints}</div></div>
            <div>
              <div className="text-stone-500 text-xs uppercase mb-1">Public allowlist ({safety.public_allowlist.length})</div>
              <ul className="mono text-xs space-y-0.5 text-stone-400">{safety.public_allowlist.map((p) => <li key={p}>{p}</li>)}</ul>
            </div>
            <div>
              <div className="text-stone-500 text-xs uppercase mb-1">Internal enrichment allowlist</div>
              <ul className="mono text-xs space-y-0.5 text-stone-400">
                {safety.account_internal_allowlist.length ? safety.account_internal_allowlist.map((p) => <li key={p}>{p}</li>) : <li>none (enrichment host not configured)</li>}
              </ul>
              <div className="text-xs mt-1">Enrichment session: {safety.account_enrichment_enabled ? <span className="text-emerald-300">configured</span> : <span className="text-stone-500">not configured (deferred)</span>}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
